<template>
  <div id="vue-gf-frp-leaderboard">
    <div class="container">
      <div class="row mb-2">
        <div class="h1">
          {{ title }}
        </div>
      </div>
      <div class="row">
        <div
          v-for="(fundraiser, idx) in topFundraisers"
          :key="idx"
          class="col-6 col-md-4 col-lg-2 border p-0 m-0 border-0"
        >
          <div class="frp-block">
            <fundraiser-block
              :fundraiser="fundraiser"
              :block-background-color="driverButtonColour"
              :text-color="driverTextColour"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import Base from './Base.vue';
import FundraiserBlock from './FundraiserBlock.vue'
import 'promise-polyfill/src/polyfill'
import constants from '../common/constants';

export default {
  name: 'TopFundraisers',
  components: {
    FundraiserBlock
  },
  mixins: [Base],
  props: {
    title: {
      type: String,
      default: 'Top Fundraisers',
    },
    beneficiaryId: {
      type: String,
      default: '',
    },
    blockBackgroundColor: {
      type: String,
      default: '',
    },
    blockTextColor: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const topFundraisers = ref([])
    const driverButtonColour = ref('')
    const driverTextColour = ref('')

    const getTopFundraisers = () => {
      axios.get(`https://${props.apiDomain}/v1/pages/search?eventcampaignid=${props.eventId}&beneficiaryaccountid=${props.beneficiaryId}&pagetype=${props.pageType}&pagesize=${props.size}&sortorder=${props.sortOrder}&sortby=${props.sortBy}&tags=${props.tags}`)
      .then(res => {
        res.data.Pages.forEach(element => {
          var total =  element.PageType == constants.FUNDRAISING_PAGE_TEAM_TYPE_ID ? element.Team.TeamTotal : element.Total
          topFundraisers.value.push({
            id: element.Id,
            name: `${element.CreatorName}`,
            raised: total,
            pageUrl: element.Url,
            imageUrl: element.ImagePath,
            title: element.PageTitle
          })

          if (driverButtonColour.value === '')
            driverButtonColour.value = element.Event.EventTheme.DriverButtonBackgroundColour

          if (driverTextColour.value === '')
            driverTextColour.value = element.Event.EventTheme.DriverButtonFontColour
        })
      })
    }

    onMounted(() => {
      getTopFundraisers()
      driverButtonColour.value = props.blockBackgroundColor
      driverTextColour.value = props.blockTextColor
    })

    return {
      topFundraisers,
      driverButtonColour,
      driverTextColour,
      getTopFundraisers,
    }
  },
}
</script>

<style lang="css" scoped>
.dummy {
    margin-top: 100%;
}
.frp-block {
    margin-top: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
</style>
